import React, { PropsWithChildren } from "react";
//#region types
import { TitledContainerProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import TitledContainerHeader from "./titledContainerHeader";
//#endregion

const TitledContainerInner: React.FC<PropsWithChildren<TitledContainerProps>> = (props) => {
  const { children, ...headerProps } = props;

  return (
    <>
      <TitledContainerHeader {...headerProps} />
      <Grid item container direction="column">
        {children}
      </Grid>
    </>
  );
};

export default TitledContainerInner;
